import { render } from "./SoftwareIntegrations.vue?vue&type=template&id=be823494"
import script from "./SoftwareIntegrations.vue?vue&type=script&lang=js"
export * from "./SoftwareIntegrations.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__